<template>
  <div class="DetailInviteDown">

<!--
    v-show="isNotVip"
-->
    <div
    >
      <!-- 邀请用户 -->
      <div
        v-if="inviteDownInfo.is_download == 0"
        class="invite-bar"
        @mouseover="isShowRule = true"
        @mouseleave="isShowRule = false"
      >
        <div class="txt-invite">邀请好友免费下载此图</div>
        <div class="invite-user"
             @mouseover.stop="isShowRule = false"
        >

          <!-- 已邀请  -->
          <div class="img"
               v-for="(vo,idx) in inviteDownInfo.users"
               :key="idx"
          >
            <img :src="avatar" alt="">
            <div class="user-id">潮国ID：{{ vo }}</div>
          </div>

          <!-- 未邀请  -->
          <template v-if=" inviteDownInfo.times <  detail._inviteNumber">
            <div class="img text-copy"
                 v-for="(vo,idx) in (detail._inviteNumber - inviteDownInfo.times)"
                 :key="idx"
                 @click="share"
            >
              <!--              <img :src="PAGE_PATH.BASE_IMG_UPLOAD + 'tupian/detail/invite-down/avatar-default.svg' " alt="">-->
              <i class="iconfont icon-a-adduser"/>
              <div class="user-id ">点击复制，邀请好友助力</div>
            </div>
          </template>


        </div>

        <div class="invite-rule " v-if="isShowRule">

          <div class="text-title">
            活动规则：
          </div>
          <div class="text-rule">
            1.您将链接分享给好友，达到人数要求（邀请的好友须注册成功）即可免费下载此图的源文件。<br>
            2.免费下载作品仅限学习交流，不可商用。如需商用，请购买会员授权。<br>
            3.免费下载此图，有效期截止到当天24点。
          </div>

        </div>
      </div>

      <!-- 邀请成功 bar -->
      <div
        v-if="inviteDownInfo.is_download == 1"
        class="invite-bar-succ">
        <div class="txt-invite">已成功邀请好友</div>
        <div class="invite-down">
          <i class="iconfont icon-download1"></i>
          <span class="txt-free-down" @click="shareDown">免费下载</span>
        </div>
      </div>
    </div>


    <!-- 助力成功 -->
    <CgModalMiddle
      @close="isShow = false"
      v-if="isShow"
    >
      <div slot="modal_content" class="modal-content">
        <div class="title">
          助力成功，欢迎来到潮国创意
        </div>
        <div class="desc">
          送您10次免费下载机会
        </div>
        <div class="tips">
          快来浏览网站，发现更多宝藏素材吧！
        </div>
      </div>
    </CgModalMiddle>

    <!-- 助力失败 -->
    <CgModalMiddle
      @close="isShowByFailDialog = false"
      v-if="isShowByFailDialog"
    >
      <div slot="modal_content" class="modal-content-fail">
        <div class="title">
          助力失败，您已是潮国创意用户
        </div>
        <div class="desc">
          快来浏览网站，发现更多宝藏素材吧！
        </div>
      </div>
    </CgModalMiddle>


  </div>
</template>

<script>
import {PAGE_PATH} from '@/constant/PAGE_PATH'
import {mapState} from "vuex";
import {getDetailInviteStatus, statDetailInviteShare} from "@/api/act/detail-invite-down";
import {fnClipboard} from "@/fn";

export default {
  name: "DetailInviteDown",

  props: {
    detail: {
      type: Object,
      default: () => {
      }
    },
    inviteDownInfo: {
      type: Object,
      default: () => {
      }
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    isShowByFailDialog: {
      type: Boolean,
      default: false,
    },

    isNotVip: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('user', ['avatar', 'uniq_id', 'isLogin'])
  },
  data() {
    return {
      // isShow: false,
      // isShowByFailDialog: false,
      isShowRule: false,
      PAGE_PATH,

      isInviteFinish: false
    }
  },
  mounted() {
    this.init();
  },
  methods: {

    init() {
    },

    share() {
      let txt = `拜托拜托！为我助力【潮国创意】设计素材，真的可以免费下载，我体验过了！https://chaopx.com/detail/${this.detail.uniq_id}?u=${this.uniq_id}`;
      fnClipboard.copy(txt);

      statDetailInviteShare().then(res => {

      })
    },

    close() {
      this.$emit('close')
    },
    closeFailDialog() {
      this.$emit('closeFailDialog')
    },

    shareDown() {
      this.$emit('shareDown')
    }

  }
}
</script>

<style lang="scss" scoped>


.DetailInviteDown {

  @include Position(1,2,0,-32px);

  .invite-bar {
    width: 242px;
    height: 32px;
    background: #F6F6FF;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 6px 0 14px;
    box-sizing: border-box;
    font-size: 13px;
    color: #7272F8;
    position: relative;
    z-index: 10;
    transition: all 0.5s ease;
    cursor: pointer;
    //overflow: hidden;

    /*width: 242px;
    height: 32px;
    background: #6969FF;
    border-radius: 0px 0px 0px 16px;
    color: #FFFFFF;*/

    width: 242px;
    height: 32px;
    background: #F0F0FF;
    border-radius: 10px;

    .invite-user {
      display: flex;
      align-items: center;

      .img {
        width: 22px;
        height: 22px;
        background: #B7BACD;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 6px;
        border-radius: 50%;
        position: relative;

        &:last-child {
          margin-right: 0;
        }

        &:hover {
          .user-id {
            display: block;
          }
        }

        .user-id {
          width: 161px;
          height: 52px;
          background: #FFFFFF;
          box-shadow: 0px 0px 12px 0px rgba(66, 72, 102, 0.08);
          position: absolute;
          top: 32px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 10;
          font-size: 12px;
          color: #2D2B33;
          line-height: 52px;
          text-align: center;
          border-radius: 14px;
          display: none;

          &:after {
            display: inline-block;
            content: '';
            width: 100%;
            height: 10px;
            background: transparent;
            position: absolute;
            top: -10px;
            left: 0;

          }

          &:before {
            display: inline-block;
            content: '';
            width: 10px;
            height: 10px;
            position: absolute;
            top: -5px;
            left: 76px;
            background: #FFFFFF;
            transform: rotate(135deg);
          }
        }

        img {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }

      .icon-a-adduser{
        color: #FFFFFF;
      }

      .text-copy {
        background: rgba(105, 105, 255, 0.30);

        &:hover {
          background: #FFFFFF;

          .icon-a-adduser {
            color: $color-primary;
          }
        }
      }
    }

    &:hover {
      border-radius: 16px 16px 0 0;
      overflow: visible;

      .invite-rule {
        opacity: 1;
      }
    }

    .invite-rule {
      width: 100%;
      position: absolute;
      top: 32px;
      left: 0;
      font-size: 12px;
      color: #2D2B33;
      z-index: 5;
      padding: 16px 18px 18px;
      box-sizing: border-box;
      background: #FFFFFF;
      box-shadow: 0px 0px 12px 0px rgba(66, 72, 102, 0.08);
      border-radius: 0 0 16px 16px;
      opacity: 0;
      transition: all 0.5s ease;

      .text-title {
        height: 16px;
        font-size: 12px;
        color: #2D2B33;
        line-height: 16px;
        margin-bottom: 4px;
      }

      .text-rule {
        font-size: 12px;
        color: #2D2B33;
        line-height: 20px;
      }
    }
  }

  .invite-bar-succ {
    width: 260px;
    height: 32px;
    background: #F5F6FA;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 4px 0 16px;
    box-sizing: border-box;

    width: 242px;
    height: 32px;
    background: #6969FF;
    border-radius: 0px 0px 0px 16px;

    width: 242px;
    height: 32px;
    background: #F0F0FF;
    border-radius: 10px;

    .txt-invite {
      font-size: 13px;
      line-height: 16px;
      color: rgba(105, 105, 255, 1);
    }

    .invite-down {
      width: 98px;
      height: 26px;
      background: rgba(105, 105, 255, 1);
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 13px;
      cursor: pointer;
      color: #FFFFFF;


      .icon_down {
        //@include BgImage(12px, 12px, 'tupian/detail/invite-down/download.svg');
        margin-right: 6px;
      }

      .icon-download1 {

        font-size: 13px;
        margin-right: 6px;

      }

      .txt-free-down {
        font-size: 13px;
        line-height: 26px;
        position: relative;
        top: -1px;
      }

      &:hover {
        background: rgba(95, 94, 232, 1);
        color: #FFFFFF;

        .txt-free-down {
          color: #FFFFFF;
        }
      }
    }

  }

  /* 拉新成功弹框 */
  .modal-content {
    @include BgImage(464px, 300px, 'tupian/detail/invite-down/modal-succ.png');
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      height: 24px;
      font-size: 18px;
      color: #424866;
      line-height: 24px;
      margin-top: 139px;
    }

    .desc {
      height: 28px;
      font-size: 20px;
      font-weight: bold;
      color: #6969FF;
      line-height: 28px;
      margin: 10px 0 2px;
    }

    .tips {
      height: 28px;
      font-size: 14px;
      color: rgba(89, 96, 136, 0.75);
      line-height: 28px;
    }
  }

  /* 拉新失败弹框 */
  .modal-content-fail {
    @include BgImage(464px, 300px, 'tupian/detail/invite-down/modal-fail.png');
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      height: 24px;
      font-size: 18px;
      color: #424866;
      line-height: 24px;
      margin: 161px 0 8px;
    }

    .desc {
      height: 28px;
      font-size: 14px;
      color: #596088;
      line-height: 28px;
    }
  }


  /deep/ .Modal-wrap {
    .Modal-cover {
      background: transparent !important;
      display: none;
    }

    .Modal {

      .Modal-close {
        top: 12px;
        right: 12px;
      }

    }
  }
}
</style>
